import React, { useRef, useEffect } from 'react';
import style from './RankPrizesTable.css';
import { usePortletTranslations } from '../../../../system/Portlet/hooks';

export const RankPrizesTable = ({ data, scrollTo }) => {
    const t = usePortletTranslations();

    const transformData = (myData) => {
        const output = [];
        myData.forEach(e => {
            if (e.hiRank === e.loRank) {
                output.push({ position: e.hiRank, description: e.description });
            } else if (e.hiRank < e.loRank) {
                for (let i = e.hiRank; i <= e.loRank; i++) {
                    output.push({ position: i, description: e.description });
                }
            }
        });
        return output;
    };

    useEffect(() => {
        if (scrollTo.scrolling) {
            const rect = refs.current[scrollTo.scrollTo].getBoundingClientRect();
            const yOffset = window.scrollY + rect.top - 50;
            window.scrollTo({
                top: yOffset,
                behavior: 'smooth'
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refs = useRef([]);
    refs.current = [];

    const addToRefs = (el) => {
        if (el && !refs.current.includes(el)) {
            refs.current.push(el);
        }
    };

    const transformedData = transformData(data);

    const detectColorForPosition = (index) => {
        if (index === 0) {
            return style.firstColor;
        } else if (index === 1) {
            return style.secondColor;
        } else if (index === 2) {
            return style.thirdColor;
        }
        return style.generalColor;

    };

    const dataToRender = transformedData.map((e, index) => {
        const className = `${style.leftPositionWrapper} ${detectColorForPosition(index)}`;
        return (
            <li ref={addToRefs} className={style.horizontalList} key={e.description + index}>
                <div className={style.prizesTableRow}>
                    <div className={className} >
                        <div className={`${style.leftTitlePosition} ${index > 2 ? style.rankSmall : ''}`}>{e.position}</div>
                    </div>
                    <div className={style.rightTitle}>{e.description}</div>
                </div>
                <div className={style.divider} />
            </li>
        );
    });

    if (data.length > 0) {
        return (
            <div className={style.wrapper}>
                <div className={style.headerTitleWrapper}>
                    <div className={style.headerTitle}>{t('rankprizes')}</div>
                </div>
                <div className={style.headerRow}>
                    <div className={style.leftTitle}>{t('position')}</div>
                    <div className={style.rightTitle}>{t('competitorsTable.head.prize')}</div>
                </div>
                <div>
                    <ul className={style.clearDefStyles}>{dataToRender}</ul>
                </div>
            </div>);
    }
    return (<></>);
};

